import React from 'react'
import './InsiderBuyTogetherLoading.scss'

export default function InsiderBuyTogetherLoading() {
  return (
   <div className="insider-skeleton-card-bt">
      <div className="skeleton-image-bt" />
      <div className="skeleton-line-bt" />
      <div className="skeleton-line short-bt" />
      <div className="skeleton-price-bt" />
    </div>
  )
}
